exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipeCard__skeleton {\n  display: inline-block;\n  background-color: var(--color__gray--lighter);\n  padding-bottom: var(--spacing__vertical--1); }\n\n.recipeCard__skeleton--medium {\n  width: 33%; }\n\n.recipeCard__skeleton--large {\n  width: 100%; }\n\n.recipeCard__image--skeleton {\n  padding-bottom: 100%;\n  background-color: var(--color__gray--lighter); }\n", ""]);

// exports
